import { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterForm() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email });
      toast.success(
        data.already_subscribed
          ? "You're already on the list."
          : "Subscribed — check your inbox."
      );
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form
      onSubmit={submit}
      data-testid="newsletter-form"
      className="flex flex-col sm:flex-row gap-2"
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@spookymail.com"
        data-testid="newsletter-email-input"
        className="flex-1 brut bg-white text-black px-3 py-2 placeholder:text-gray-500 focus:outline-none"
      />
      <button
        type="submit"
        disabled={busy}
        data-testid="newsletter-submit"
        className="brut pcs-bg-orange text-black px-4 py-2 font-bold uppercase text-sm tracking-wide brut-press disabled:opacity-60"
      >
        {busy ? "..." : "Subscribe"}
      </button>
    </form>
  );
}
